module.exports = __webpack_public_path__ + "static/media/unimed&Unihealth.f86a64f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/apps/BCOMS/resources/sponsors/unimed&Unihealth.png
// module id = 1150
// module chunks = 0